$(document).ready( function(){
	TileGridTextAlignment();
	BannerTextCentering();
	resizeIFrame();
	PlayVideo();
});

$(window).resize( function() {
	TileGridTextAlignment();	
	BannerTextCentering();
	resizeIFrame();
});

/*
	Position text on homepage banner center vertically
*/
function TileGridTextAlignment() {
	if ($('.module--TileGridModule').length > 0){

		// Square up boxes
		if( $(window).width() > 600) {
			$('.module--TileGridModule .grid__tile').each(function() {
				var width = $(this).outerWidth();

				if( $(this).hasClass('single-tile') ) {
					$(this).height( width );
				} else {
					$(this).height( width / 2);
				}
			});
		}

		// Vertically center text
		$('.module--TileGridModule .grid__tile').each(function() {
			var paraHeight = $(this).children('p').outerHeight();
			var paraWidth = $(this).children('p').outerWidth();
			$(this).children('p').height(paraHeight).width(paraWidth).addClass('centered');

		});
	}
}

function BannerTextCentering() {
	if( $('.module--BannerLinkModule .banner-animated.content').length > 0 && $(window).width() > 400 ) {
		var bannerHeight = $('.banner-animated.content').height();
		var textHeight = $('.banner-animated.content h1').height();
		var padding = (bannerHeight - textHeight) / 2;
		
		$('.banner-animated.content h1').css('top', padding + 'px');
	}
}

/*
	Video Module
	Swap out placeholder image for iframe and play
*/
function PlayVideo() {	
	if( $('.module--VideoModule').length > 0 ) {
		$('.module--VideoModule .video-play').click(function(evt) {
			evt.preventDefault();
			$('.placeholder').fadeOut();
		});
	}
}

function resizeIFrame() {
	if ($('iframe').length > 0){
	    $('iframe').each(function(){
	    	// get width of inner and calc height based on video proportions, apply height to inner
	    	var outerWidth = $(this).closest('.inner.typography').outerWidth();
	    	var newHeight = outerWidth * 0.5623;
	        $(this).closest('.inner.typography').css('height', newHeight + 'px');
	    });
	}
}